<div class="embed-video">
  <brt-embed-video-youtube *ngIf="EmbedVideoType.YOUTUBE === embedVideoType" [youtube-str]="youtubeIframeStr" [object-fit]="objectFit"></brt-embed-video-youtube>
</div>
